import React, { useState, useEffect } from "react";
import ClaimantsInfo from "./ClaimantsInfo";
import { formatPoilcyDate } from "shared/dateFormat";
import classNames from "classnames";
import { claimsResultModel } from "models/claims.model";
import { getClaimInfo, getWarnings } from "services/claims.service";
import WarningsModal from "shared/Modal/WarningsModal/WarningsModal";

const getSearchParameter = () => {
  let type = localStorage.getItem("searchElement");
  return type;
};
const getHighlightedText = (text, highlight) => {
  // Split text on highlight term, include term itself into parts, ignore case
  if (text) {
    let parts = text.split(new RegExp(`(${highlight})`, "gi"));
    return (
      <span>
        {parts.map((part) =>
          part.toLowerCase() === highlight.toLowerCase() ? (
            <span style={{ background: "yellow" }}>{part}</span>
          ) : (
            part
          ),
        )}
      </span>
    );
  }
};

export default function ClaimsSearchResult(props) {
  const [claimNo] = props.data;
  const { defaultSearchValue, handleWarnings } = props;
  const [claimsDetails, setClaimsDetails] = useState(claimsResultModel);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true); // note this flag denote mount status
    getClaimInfo(claimNo)
      .then((data) => {
        setIsLoading(false);
        if (data.data.statusCode === 200) {
          if (isMounted) {
            setClaimsDetails(data.data.response);
          }
        } else {
          setErrorMessage("Something Went Wrong...!");
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
    return () => {
      isMounted = false;
      setIsLoading(false);
    }; // use effect cleanup to set flag false, if unmounted
  }, []);

  return (
    <>
      <div className="card mb-2" style={{ border: "none" }}>
        <div
          className={"card-body"}
          style={{
            height: "auto",
            borderRadius: "4px",
            padding: "1.25rem 1rem 1.25rem 1rem",
          }}
        >
          {isLoading ? (
            <div>Loading...</div>
          ) : errorMessage !== null ? (
            <div className={"text-center"}>
              <div className={"search-error"}>{errorMessage}</div>
            </div>
          ) : (
            <>
              <div>
                <div
                  className={"flex-box"}
                  style={{ padding: " 0px 0px 0px 10px" }}
                >
                  <div style={{ flexGrow: 1 }}>
                    <div className={"search-label"}>Claim No</div>
                    <div
                      className={"search-items-content actionIcon"}
                      style={{ color: "#03a9f4" }}
                      onClick={() => {
                        handleWarnings(claimsDetails, claimNo);
                      }}
                    >
                      {getSearchParameter() === "claimNo"
                        ? getHighlightedText(claimNo, defaultSearchValue)
                        : claimNo}
                    </div>
                  </div>
                  <div style={{ flexGrow: 1 }}>
                    <div className={"search-label"}>Policy No.</div>
                    <div className={"search-items-content"}>
                      {claimsDetails.policyNo
                        ? getSearchParameter() === "policyNo"
                          ? getHighlightedText(
                              claimsDetails.policyNo,
                              defaultSearchValue,
                            )
                          : claimsDetails.policyNo
                        : "-"}
                    </div>
                  </div>
                  <div style={{ flexGrow: 1 }}>
                    <div className={"search-label"}>DOL</div>
                    <div className={"search-items-content"}>
                      {claimsDetails.dol
                        ? formatPoilcyDate(claimsDetails.dol)
                        : "-"}
                    </div>
                  </div>
                  <div style={{ flexGrow: 1 }}>
                    <div className={"search-label"}>Status</div>
                    <div>
                      <span
                        title={claimsDetails.status}
                        className={classNames({
                          "active-status": claimsDetails.status === "ACTIVE",
                          "suspended-status": claimsDetails.status === "CLOSED",
                          "new-status": claimsDetails.status === "NEW",
                          "notice-status": claimsDetails.status === "NOTICE",
                          "expired-status": claimsDetails.status === "EXPIRED",
                        })}
                      >
                        {claimsDetails.status ? claimsDetails.status : "-"}
                      </span>
                    </div>
                  </div>
                  <div style={{ flexGrow: 1 }}>
                    <div className={"search-label"}>Reported Date </div>
                    <div className={"search-items-content"}>
                      {claimsDetails.rptDate
                        ? formatPoilcyDate(claimsDetails.rptDate)
                        : "-"}
                    </div>
                  </div>
                  <div style={{ flexGrow: 1 }}>
                    <div className={"search-label"}>Reported By</div>
                    <div className={"search-items-content"}>
                      {claimsDetails.reportedBy !== ""
                        ? claimsDetails.reportedBy
                        : "-"}
                    </div>
                  </div>
                  <div style={{ flexGrow: 1 }}>
                    <div className={"search-label"}>Driver</div>
                    <div className={"search-items-content"}>
                      {claimsDetails.drivName ? claimsDetails.drivName : "-"}
                    </div>
                  </div>
                  <div style={{ flexGrow: 1 }}>
                    <div className={"search-label"}>VIN 1</div>
                    <div className={"search-items-content"}>
                      {claimsDetails.vin ? claimsDetails.vin : "-"}
                    </div>
                  </div>
                  <div style={{ flexGrow: 1 }}>
                    <div className={"search-label"}>Under Investigation</div>
                    <div className={"search-items-content"}>
                      {claimsDetails.isCovInvestigation ? "Y" : "N"}
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
              <ClaimantsInfo
                key={claimNo}
                {...props}
                data={claimsDetails}
                isLoading={isLoading}
                defaultSearchValue={defaultSearchValue}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
}
